// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__yH8eH","Links":"Navigation_Links__J4zQ0","Spacer":"Navigation_Spacer__2wX3P"};